<template>
    <BaseSelect
      v-model="modelValue"
      v-bind="$attrs"
      :options="CASH_CALL_SUPPORTING_DOCUMENT_OPTIONS"
      :displayType="displayflex" 
      size="sm"
      label="Document Type"
      rules="required"
    >
      <template v-slot:label>Upload Document Type<span class="text-danger">*</span> </template>
  
      <template v-slot:first>
        <b-form-select-option :value="undefined"
          >Select</b-form-select-option
        >
      </template>
    </BaseSelect>
  </template>
  
  <script>
  import { defineComponent, computed } from '@vue/composition-api'  
  import { CASH_CALL_SUPPORTING_DOCUMENT_OPTIONS } from '@constants'  
  import { BaseSelect } from '@components/base'
  
  export default defineComponent({
    name: 'CashCallUploadDocumentType',
    components: {
      BaseSelect
    },
    props: {
      value: String,
      displayType: String
    },
    emits: ['input'],
    setup(props, { emit }) {   
  
      const displayflex = "dropdownWidth"

      const modelValue = computed({
        get: () => props.value,
        set: (newValue) => emit('input', newValue)
      })   
  
      return {
        CASH_CALL_SUPPORTING_DOCUMENT_OPTIONS,  
        modelValue,
        displayflex
      }
    }
  })
  </script>
  